import script from "./workflow-review-status-block.vue?vue&type=script&lang=ts&setup=true"
export * from "./workflow-review-status-block.vue?vue&type=script&lang=ts&setup=true"

import "./workflow-review-status-block.vue?vue&type=style&index=0&id=c7fd89d3&lang=css"

const __exports__ = script;

export default __exports__